import { Pipe, PipeTransform } from '@angular/core';
import { DataPoint } from 'app/shared/models';

@Pipe({
    name: 'valueByLabel',
    standalone: false
})
export class DataPointByLabelPipe implements PipeTransform {
  transform(dataPoints: DataPoint[], label: string): number {
    if (dataPoints == null) { dataPoints = []; }
    const dataPoint = dataPoints.find(l => l.label === label);
    return dataPoint !== undefined ? dataPoint.value : 0;
  }
}
